import {useEffect} from "react";
import ReactGA4 from "react-ga4";

// Esto lo inicializa el propio pixel en la plantilla symfony
const InitializeGoogleAnalytics = () => {
    // Initialize GA4 - Add your measurement ID
    ReactGA4.initialize("G-0T1VNBBJKR");

    console.log("GA INITIALIZED");
};

const TrackGoogleAnalyticsEvent = (
    event
) => {
    useEffect(() => {

        const eventName = "form_" + event;
        const uid = window.location.hash.replace('#', '');

        console.log("GA event:", eventName, ": uid: ", uid);

        // Send GA4 Event
        ReactGA4.event(eventName, {
            uid: uid
        });

        // ReactGA4.event({
        //     category: category,
        //     action: action,
        //     label: label,
        // });
    }, []);
};

export {InitializeGoogleAnalytics, TrackGoogleAnalyticsEvent};